/**
 *  An error that occurred within the SDK. Thrown when no or invalid [ShopConfig](../interfaces/shopconfig.html)
 *  is provided or when something goes wrong while transforming and exposing data.
 */
export default class ShopError extends Error {
    /**
     *  @internal Used to construct ShopErrors
     */
    constructor(message) {
        super(message);
        /**
         *  The name of the error.
         */
        this.name = 'ShopError';
        // Obscure typescript -> es5 transpile fix
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
//# sourceMappingURL=shop.error.js.map